<template>
  <q-form ref="form" :greedy="true" @submit.prevent="emits('nextStep')">
    <q-input v-model="url"
             :rules="[
                 val => val && val.length > 0 || 'Please enter URL',
                 val => isValidURL(val) || 'Should be a valid URL'
                 ]"
             clearable
             label-slot
             name="url"
             @keydown.tab.enter.prevent="emits('nextStep')"
             outlined type="url">
      <template v-slot:label>
        <span class="text-grey-10 text-caption">Paste the
          <span class="q-px-sm bg-deep-orange text-white rounded-borders"
                style="text-decoration: underline;">destination URL</span> here
        </span>
      </template>
    </q-input>
  </q-form>
</template>

<script setup>
import {ref} from 'vue';

const form = ref();
const url = ref('');
defineExpose({url});
const emits = defineEmits(['nextStep']);
</script>

<script>
export default {
  name: "Step1",
  methods: {
    isValidURL(str) {
      const pattern = new RegExp('^((\\w{2,}:\\/\\/)|www\\.)' + // protocol
          '((([a-zA-Z\\d]([a-zA-Z\\d-]*[a-zA-Z\\d])*)\\.)+[a-zA-Z]{2,}|' + // domain name
          '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
          '(\\:\\d+)?(\\/[-a-z\\d%_.~:+()]*)*' + // port and path
          '(\\?[;&a-zA-Z\\d%_.~:+=-]*)?' + // query string
          '(\\#[-a-zA-Z\\d_\.=]*)?$', 'i'); // fragment locator
      return !!pattern.test(str);
    }
  }
}
</script>

<style scoped>

</style>
